export default __webpack_public_path__ + "static/media/banner3.0a014ea0.png";